// export { default } from '~/views/about/_index';
export { about as default } from './page/_index';

import { json, LinksFunction } from '@remix-run/node';
import type { MetaFunction } from '@remix-run/node';
import { externalAction, externalLoader } from '~/utils/externalLoader.server';
export const action = externalAction;
export const loader = externalLoader;
import { useTranslation } from 'react-i18next';

export const meta: MetaFunction = ({ data }: any) => {
	let { t } = useTranslation(['about']);

	let lang = data.userLanguage === 'de' ? '' : data.userLanguage + '/';

	return [
		{
			title: t('routeTitle'),
		},
		{
			name: 'title',
			content: t('routeTitle'),
		},
		{
			property: 'og:title',
			content: t('routeTitle'),
		},
		{
			name: 'twitter:title',
			content: t('routeTitle'),
		},

		{
			name: 'description',
			content: t('routeOther'),
		},
		{
			property: 'og:description',
			content: t('routeOther'),
		},
		{
			name: 'twitter:description',
			content: t('routeOther'),
		},
		{
			property: 'og:url',
			content: 'https://northrock.software/' + lang + 'about/',
		},
		{
			name: 'twitter:url',
			content: 'https://northrock.software/' + lang + 'about/',
		},
	];
};

//* gallery
import img1 from '~/content/images/about_us/1.webp';
import img2 from '~/content/images/about_us/2.webp';
import img3 from '~/content/images/about_us/3.webp';
import img4 from '~/content/images/about_us/4.webp';
import img5 from '~/content/images/about_us/5.webp';
import img6 from '~/content/images/about_us/6.webp';

//* team
import leon from '~/content/images/about_us/leon_bernard.webp';
import daniel from '~/content/images/about_us/daniel_partschev.webp';

export const links: LinksFunction = () => {
	return [
		// {
		//   rel: 'canonical',
		//   href: 'https://northrock.software/about',
		// },
		{
			rel: 'preload',
			href: img1,
			as: 'image',
		},
		{
			rel: 'preload',
			href: img2,
			as: 'image',
		},
		{
			rel: 'preload',
			href: img3,
			as: 'image',
		},
		{
			rel: 'preload',
			href: img4,
			as: 'image',
		},
		{
			rel: 'preload',
			href: img5,
			as: 'image',
		},
		{
			rel: 'preload',
			href: img6,
			as: 'image',
		},
		{
			rel: 'preload',
			href: leon,
			as: 'image',
		},
		{
			rel: 'preload',
			href: daniel,
			as: 'image',
		},
	];
};
